// extracted by mini-css-extract-plugin
export var checkbox = "_46-0";
export var circle = "_46-3";
export var horizontalContainer = "_46-7";
export var sm = "_46-5";
export var switch0 = "_46-2";
export var switchDisabled = "_46-8";
export var switchEnabled = "_46-1";
export var textSwitchContainer = "_46-9";
export var textSwitchOption = "_46-a";
export var textSwitchOptionSelected = "_46-b";
export var verticalContainer = "_46-6";
export var xs = "_46-4";